import appParameters from '../../components/utils/AppParameters';
import storeManager from '../../store/StoreManager';
import { showLostSessionAlert, showSavePreloader, hasNotAccess } from '../../actions/MenuActions';
import apiService from '../../services/ApiService';
import configuration from '../../constants/Configuration';
import resumeSessionUtils from './ResumeSessionUtils';
import properties from '../../constants/Properties';

const apiServiceUtils = {
    saveTime: undefined,

    isWrong() {
        if ((appParameters.context == 'edit' || appParameters.context == 'audioTool') && (appParameters.currentUserId == -1 || appParameters.bundleVersion == undefined))
            return true;
        else
            return false;
    },
    isSafeCall(response) {
        if (appParameters.isIcsx)
            return true;

        if ((appParameters.context == 'edit' || appParameters.context == 'audioTool') && (appParameters.currentUserId == -1 || appParameters.bundleVersion == undefined))
            return false;

        if (appParameters.currentUserId == -1 && (appParameters.context == 'player' || appParameters.context == 'audioToolPlayer' || appParameters.context == 'exportPlayer' || appParameters.context == 'exportAudioPlayer')) // it's a PUBLIC production
            return true;

        // response from a GetSessionInfo call
        if (response) {
            const currentUserId = response.userId;
            const startUserId = appParameters.currentUserId;

            if (currentUserId > 0 && startUserId > 0 && currentUserId == startUserId)
                return true;
            else
                return false;
        } else
            return false;
    },
    showLostSessionAlert(value = true) {
        const store = storeManager.getStore();

        if (value)
            store.dispatch(showLostSessionAlert(1));
        else
            store.dispatch(showLostSessionAlert(-1));
    },
    showNoAccessAlert() {
        const store = storeManager.getStore();
        store.dispatch(hasNotAccess(true));
    },
    initLostSessionTimer() {
        setInterval(this.checkInternetConnection.bind(this), 5 * 1000);

        if (configuration.LOAD_LOCAL == true)
            return;

        resumeSessionUtils.init();
        setInterval(this.checkSession.bind(this), 20 * 1000);
    },
    checkSession() {
        this.checkSavePreloader();

        // apiService.getSessionInfo() // check if the user has session
        //     .then(response => {
        //         if (this.isSafeCall(response) == false) {
        //             return this.showLostSessionAlert(true);
        //         }
        //     });
    },
    checkSavePreloader() {
        const state = storeManager.getState();
        const isSavePreloader = state.menu.showSavePreloader;

        if (isSavePreloader && isSavePreloader == true) {
            const currentTime = this.getCurrentTime();

            if (this.saveTime > 0 && (currentTime - this.saveTime) > 6 * 1000) {
                const store = storeManager.getStore();
                store.dispatch(showSavePreloader(false));
            }
        }
    },
    getCurrentTime() {
        const date = new Date();
        const currentTime = date.getTime();

        return currentTime;
    },
    executeSafeApiCall(callbackFunction, failCallbackFunction = undefined,) {
        if (appParameters.isTest) {
            if (callbackFunction)
                callbackFunction();

            return;
        }

        apiService.getSessionInfo() // check if the user has session
            .then(response => {
                if (this.isSafeCall(response) == true) {
                    if (callbackFunction)
                        callbackFunction();
                } else {
                    if (failCallbackFunction)
                        failCallbackFunction();

                    // Lost SessionAlert
                    this.showLostSessionAlert(true);

                    return;
                }
            });
    },
    executeGetMediaFilesCall(parseMediaItems) {
        const contentType = 'all';
        apiService.loadMediaFiles(contentType, configuration.MEDIA_FILES_PAGE_LIMIT).then(result => {
            const items = result.media;

            if (parseMediaItems)
                parseMediaItems(items);
        });
    },

    /*********** Internet connection *************/
    checkInternetConnection() {
        const store = storeManager.getStore();

        if(!window.navigator.onLine){
            store.dispatch(showLostSessionAlert(5));
        } else {
            const showLostSessionAlertValue = storeManager.getState().menu.showLostSessionAlert;

            if (showLostSessionAlertValue == 5) { // it's an non internet connection alert
                store.dispatch(showLostSessionAlert(-1));
                // resumeSessionUtils.resumeSession();
            }
        }
    },
    getNoInternetConnectionAlertHeight() {
        if (storeManager.getState().menu.showLostSessionAlert == 5)
            return properties.CLIPART_BUTTON_HEIGHT;

        return 0;
    }
};

export default apiServiceUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ApiServiceUtils.js
 **/